import { NgModule } from '@angular/core';
import {
  LoginComponent,
  TermsAndConditionsComponent,
  CancelPolicyComponent,
  SidebarComponent
} from '../../components';
import { ResetPasswordComponent } from '../../components/reset-password/reset-password.component';
import { UpdatePasswordComponent } from '../../components/update-password/update-password.component';
import { LoginRouting } from '../routing';
import { SharedModule } from './shared.module';

@NgModule({
  imports: [
    LoginRouting,
    SharedModule,
  ],
  declarations: [
    LoginComponent,
    CancelPolicyComponent,
    SidebarComponent,
    TermsAndConditionsComponent,
    UpdatePasswordComponent
  ],
  exports: [
    CancelPolicyComponent,
    TermsAndConditionsComponent,
    SharedModule
  ]
})
export class LoginModule {
}
